import {Component, OnInit } from "@angular/core";

@Component({
  selector: 'app-training-section',
  templateUrl: './training-section.component.html',
  styleUrls: ['./training-section.component.scss']
})

export class TrainingSectionComponent implements OnInit {
    ngOnInit(): void {
        console.log("Training section works");
    }

}
